import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
const badgeVariants = cva("inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:scale-105", {
  variants: {
    variant: {
      default: "border-transparent bg-primary text-primary-foreground shadow-sm shadow-primary/25",
      secondary: "border-transparent bg-secondary text-secondary-foreground shadow-sm shadow-secondary/25",
      destructive: "border-transparent bg-destructive text-destructive-foreground shadow-sm shadow-destructive/25",
      success: "border-transparent bg-success text-success-foreground shadow-sm shadow-success/25",
      warning: "border-transparent bg-warning text-warning-foreground shadow-sm shadow-warning/25",
      accent: "border-transparent bg-accent text-accent-foreground shadow-sm shadow-accent/25",
      outline: "border-2 border-border text-foreground hover:border-primary hover:text-primary",
      ghost: "border-transparent bg-muted text-muted-foreground"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}
function Badge({
  className,
  variant,
  ...props
}: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}
export { Badge, badgeVariants };